import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { HttpErrorDialogComponent } from './http-error-dialog/http-error-dialog.component';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    static readonly SKIP = new HttpContextToken(() => true);

    constructor(private ngbModal: NgbModal) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.context.get(HttpErrorInterceptor.SKIP)) {
            return next.handle(request);
        }

        return next.handle(request).pipe(
            catchError(error => {
                this.handleHttpError(error);
                return throwError(error);
            })
        );
    }

    private handleHttpError(error: any): void {
        console.error('Error caught by HttpInterceptor: ', error);

        if (error instanceof HttpErrorResponse) {
            if (!error.error) {
                console.error(error);
                return;
            }

            if (error.error instanceof ErrorEvent) {
                console.error(error.error);
            } else {
                this.openErrorDialog(error.error.title ?? error.error, error.error.message, error.error.stackTrace, error.error.traceId);
            }
        }
    }

    private openErrorDialog(errTitle: string, errMsg: string, stackTrace: string, traceId?: string): void {
        const modalRef = this.ngbModal.open(HttpErrorDialogComponent);
        const componentRef = modalRef.componentInstance as HttpErrorDialogComponent;
        componentRef.errorTitle = errTitle;
        componentRef.errorMessage = errMsg;
        componentRef.stackTrace = stackTrace;
        componentRef.traceId = traceId ?? '';
    }
}
